/**
 配置管理--维修记录
 */
import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import moment from "moment";
import { Modal, Button, message } from "antd";
import { findStubOpLogList, delStubOpLog, prefixFile } from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import StubStruts from "@/utils/stubStruts";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import EditOrAddStuOpLog from "./editOrAddStuOpLog";
import { useAuth } from "@/utils/utils";

// 国际化切换语言

/**
 * 引入设备状态列表
 */

// const TabPane = Tabs.TabPane;

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class StubOpLogInfo extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOpLogInfo;
    this.isAdd = this.internationalization.btn10;
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.isFirst = true;
    this.hasSearch = false;
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      station: this.queryStationName,
      stubId: this.queryStubId,
      tableParam: {
        stubGroupName: this.queryStubName,
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
        station: this.queryStationName,
      },
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      currentParam: {},
    };
  }

  /**
   * 页面加载前调用方法，初始化查询form表单
   */
  componentWillMount() {
    /**
     * 设备状态定义
     */
    this.queryStationName = "";
    this.queryStubId = "";
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
      this.queryStationName = window.LayoutTab.tabParam.stationName
        ? window.LayoutTab.tabParam.stationName
        : "";
    }
    this.stateOption = StubStruts();
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载完成调用方法，表格数据加载，并且初始化值
   */
  componentDidMount() {
    console.log("哎哎111");
    this.fetchApi(this.state.tableParam);
    this.setState({
      stubGroupName: "",
      meterModuleId: "",
      stubId: this.queryStubId,
      station: this.queryStationName,
      tableParam: {
        stubGroupName: "",
        stubGroupId: "",
        meterModuleId: "",
        stubId: this.queryStubId,
        station: this.queryStationName,
      },
    });
  }

  /**
   * 查询form表单初始化
   */
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "场站名称", // '场站名称',
          param: {
            name: "station",
            type: "string",
          },
          labelName: "场站名称", // '场站名称:',
          required: false,
          defaultValue:
            !this.queryStationName || this.queryStationName == null || this.queryStationName == ""
              ? ""
              : this.queryStationName,
        },
        {
          type: "input",
          placeholder: "设备编号", // '设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号", // '设备编号:',
          required: false,
          defaultValue:
            !this.queryStubId || this.queryStubId == null || this.queryStubId == ""
              ? ""
              : this.queryStubId,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: this.internationalization.placeholder111, // '请选择查询起止日期',
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: [moment(new Date()).subtract(30, "d"), moment(new Date()).subtract(0, "d")],
          // defaultValue: this.query.currentDate
          //   ? [
          //       moment(new Date(this.state.currentDate[0])).subtract(0, "i"),
          //       moment(new Date(this.state.currentDate[1])).subtract(0, "i"),
          //     ]
          //   : [moment(new Date()).subtract(0, "d"), moment(new Date()).subtract(0, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: this.internationalization.title111, // '起止日期:',
          required: !1,
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.title4, // '全部',
              value: "",
            },
            {
              text: "巡检",
              value: "1",
            },
            {
              text: "清洁",
              value: "2",
            },
            {
              text: "保养",
              value: "3",
            },
            {
              text: "调试",
              value: "4",
            },
            {
              text: "故障",
              value: "5",
            },
            {
              text: "验收",
              value: "6",
            },
            {
              text: "其他",
              value: "7",
            },
          ],
          placeholder: "类型", // '类型',
          param: {
            name: "infoType",
            type: "string",
          },
          labelName: "类型", // '类型',
          required: false,
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010601")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.title16, // '查询'
                }
              : "",
            useAuth("010602")
              ? {
                  btnType: "button",
                  text: this.internationalization.btn8, // 导出
                  handler: (e, param) => {
                    this.exportData(param);
                  },
                }
              : "",
            useAuth("010603")
              ? {
                  btnType: "button",
                  // icon: 'search',
                  text: "新建", // '查询'
                  handler: (record) => {
                    this.isAdd = this.internationalization.btn9;
                    this.setState({
                      seeStubStatusVisible: true,
                      stubId: null,
                    });
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        // stubGroupName: this.queryStubName,
        // powerBoxId: localStorage.meterModuleId,
        meterId: this.queryMeterModuleId,
        stubId: this.queryStubId,
        station: this.queryStationName,
      },

      context: this,
      tableKey: "tenceCom1Table",
      tablePage: "维修记录",
    };
    return formConfig;
  };

  // 数据导出
  exportData = (param) => {
    const excelUrl = `${prefixFile}/exportOpLogInfo.do`;

    param.locale = this.props.intl.locale;

    if (this.isFirst) {
      this.isFirst = false;
      param.stubId = this.queryStubId;
      param.station = this.queryStationName;
      param.startTime = moment(new Date()).subtract(30, "d").format("YYYY-MM-DD");
      param.endTime = moment(new Date()).subtract(0, "d").format("YYYY-MM-DD");
    } else {
      if (param.date && param.date != null && param.date != "") {
        console.log("新启动11");
        var times = param.date.split(",");
        param.startTime = times[0];
        if (times.length > 1) {
          param.endTime = times[1];
        }
      } else {
        console.log("新启动22");
        param.date = "";
        param.startTime = "";
        param.endTime = "";
      }
    }
    var params = "";
    Object.keys(param).forEach((key) => {
      if (param[key] !== undefined) {
        params += `${key}=${param[key]}&`;
      }
    });
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  /**
   *
   * 表格初始化
   */
  init = () => {
    this.status = null;
    this.deviceType = null;
    this.deviceModel = null;

    this.tableConfig = {
      tableKey: "tenceCom1Table",
      tableColumns: [
        {
          name: "维修对象",
          key: "opType",
          align: "left",
          width: 200,
          colType: "textCol",
          render: (value) => {
            switch (value) {
              case 1:
                return "场站";
              case 2:
                return "设备";
              default:
                return this.internationalization.title23; // '未知'
            }
          },
        },
        {
          name: "场站名称",
          key: "stationName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "设备编号", // '设备型号',
          key: "stubId",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "类型", // '设备类型'
          key: "infoType",
          align: "left",
          width: 200,
          colType: "textCol",
          render: (value) => {
            switch (value) {
              case 1:
                return "巡检";
              case 2:
                return "清洁";
              case 3:
                return "保养";
              case 4:
                return "调试";
              case 5:
                return "故障";
              case 6:
                return "验收";
              case 7:
                return "其他";
              default:
                return this.internationalization.title23; // '未知'
            }
          },
        },
        {
          name: "创建时间", // '操作时间',
          key: "createTime",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "内容", // '内容',
          key: "content",
          colType: "textCol",
          align: "left",
          width: 200,
        },

        {
          name: "关联工单", // '设备编号',
          key: "ticketId",
          colType: "textCol",
          align: "left",
          render: (value) => {},

          render: (value, row) => {
            if (value === "null") {
              return "--";
            } else if (value === "") {
              return "--";
            } else if (value === "--") {
              return "--";
            } else {
              return (
                <div
                  onClick={(e) =>
                    this.openTab(
                      {
                        // keyId: `stub_${record.key}`,
                        // StubName: record.name,

                        initSetting: { ticketType: 13, id: row.ticketId },
                      },
                      {
                        key: "9103read",
                        titleText: "工单详情", // '设备快速查询',
                      },
                    )
                  }>
                  <a>{row.ticketId}</a>
                </div>
              );
            }
          },
        },
        {
          name: "费用", // '费用',
          key: "payInfo",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "操作人姓名", // '操作人姓名',
          key: "modifyUsername",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            useAuth("010604")
              ? {
                  type: "href",
                  actionName: "编辑",
                  handler: (record) => {
                    this.isAdd = this.internationalization.btn10;
                    this.setState({
                      seeStubStatusVisible: true,
                      stubId: record,
                    });
                  },
                }
              : "",
            useAuth("010605")
              ? {
                  type: "confirm",
                  actionName: "删除",
                  render: (record) => {
                    return "删除";
                  },
                  handler: (record) => {
                    fetchHandler(delStubOpLog, {
                      logId: record.key,
                    }).then((res) => {
                      if (res && (res.code === "ok" || res.code === "success")) {
                        message.success("删除成功");
                        RefreshGrid(this.context.store, "tenceCom1Table");
                      }
                    });
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      dataApi: findStubOpLogList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
  };

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    console.log("请求参数：");
    console.log(param);

    // if (newParam.updateType === this.yunwei.wz10) {
    //   newParam.updateType = "";
    // }

    // if (newParam.frameWork === this.yunwei.wz10) {
    //   newParam.frameWork = "";
    // }

    if (this.isFirst) {
      this.isFirst = false;
      param.stubId = this.queryStubId;
      param.station = this.queryStationName;
      console.log("新启动");
      param.startTime = moment(new Date()).subtract(30, "d").format("YYYY-MM-DD");
      param.endTime = moment(new Date()).subtract(0, "d").format("YYYY-MM-DD");
    } else {
      if (param.date && param.date != null && param.date != "") {
        console.log("新启动11");
        var times = param.date.split(",");
        param.startTime = times[0];
        if (times.length > 1) {
          param.endTime = times[1];
        }
      } else {
        console.log("新启动22");
        param.date = "";
        param.startTime = "";
        param.endTime = "";
      }
      this.hasSearch = true;
    }
    const newParam = param;
    this.setState({
      tableParam: newParam,
    });
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      console.log("新启动44");
      return this.props.modalSubmit(newParam);
    } else {
      console.log("新启动55");
      this.setState({
        currentParam: newParam,
      });
      // 如果正常页面中的表单提交，请执行下面
      console.log(newParam);
      return RefreshGrid(this.context.store, "tenceCom1Table", newParam);
    }
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>

        <Modal
          title={this.isAdd}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubStatusVisible", false);
          }}>
          <EditOrAddStuOpLog
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "tenceCom1Table");
            }}
          />
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(StubOpLogInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubOpLogInfo.js